<template>
  <div class="card shadow" style="border-radius: 12px 12px 0px 0px !important">
    <div class="card-header background-MINT" style="
        padding: 5px 16px !important;
        border-radius: 12px 12px 0 0 !important;">
      <TimeCalculation :cargo="cargo" />
    </div>
    <div class="card-body pb-0">
      <div class="theme-search-results-item _mb-10 _b-n theme-search-results-item-rounded theme-search-results-item">
        <div class="theme-search-results-item-preview">
          <div class="row" data-gutter="20">
            <div class="col-md-10">
              <div class="theme-search-results-item-flight-sections">
                <div class="theme-search-results-item-flight-section">
                  <div class="row row-no-gutter row-eq-height">
                    <div class="col-md-10">
                      <div class="theme-search-results-item-flight-section-item">
                        <div class="row">
                          <div class="col-md-3">
                            <div class="theme-search-results-item-flight-section-path">
                              <div class="theme-search-results-item-flight-section-path-fly-time">
                                <p v-if="cargo.priceBased == 'به صورت صافی' || cargo.priceBased == 'بصورت صافی'">
                                  {{ formatPrice(cargo.suggestedPrice) }} تومان
                                </p>
                                <p v-if="cargo.priceBased == 'توافقی'">
                                  <strong class="title-cargo-large">توافقی</strong>
                                </p>
                                <p v-if="cargo.priceBased == 'به ازای هر تن'">
                                  به ازای هر تن:
                                  {{ formatPrice(cargo.suggestedPrice) }}
                                </p>
                              </div>
                              <div class="col-md-6">
                                <div class="theme-search-results-item-flight-section-path-line-start">
                                  <span class="from-to">
                                    {{ splitedListTo[0] }}
                                  </span>
                                  <!-- <div><ion-icon name="chevron-forward-outline"></ion-icon></div> -->
                                  <div class="theme-search-results-item-flight-section-path-line-title f-mobile">
                                    {{ splitedListTo[1] }}
                                  </div>

                                </div>
                                <div class="theme-search-results-item-flight-section-path-line"><span
                                    class="arrow-line"><ion-icon name="arrow-forward-outline"></ion-icon></span></div>
                                <div class="theme-search-results-item-flight-section-path-line-end">
                                  <span class="from-to">{{ splitedListFrom[0] }}</span>
                                  <!-- <div class="theme-search-results-item-flight-section-path-line-dot"></div> -->
                                  <div class="theme-search-results-item-flight-section-path-line-title f-mobile">
                                    {{ splitedListFrom[1] }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 class="text-center" v-if="cargo.distanceCity != 0">{{ roundNumber(cargo.distanceCity) + ' کیلومتر ' }}</h5>
                </div>
              </div>
            </div>
            <div class="">
              <div class="theme-search-results-item-book">
                <div class="theme-search-results-item-price">
                  <div class="theme-search-results-item-price">
                    <!-- <p v-if="cargo.priceBased == 'به صورت صافی'">
                      {{ formatPrice(cargo.suggestedPrice) }} تومان
                    </p>
                    <p v-if="cargo.priceBased == 'توافقی'">
                      قیمت: <strong>توافقی</strong>
                    </p>
                    <p v-if="cargo.priceBased == 'به ازای هر تن'">
                      به ازای هر تن:
                      {{ formatPrice(cargo.suggestedPrice) }}
                    </p> -->
                    <p class="title-cargo-large" v-if="cargo.title !== 'بدون عنوان'">
                      {{ cargo.title }}
                    </p>
                    <!-- <p>
                      <span
                        class="badge background-WINTER text-TEAL"
                        v-for="fleet in fleets"
                        :key="fleet.id">
                        {{ fleet.title }}
                      </span>
                    </p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-2 text-center">
      <a :href="'/' + cargo.id"
          class="btn background-ORANGE text-light btn-block btn-lg theme-search-results-item-price-btn">
          جزئیات | تماس
      </a>
      <!-- <button type="button" style="
          display: none;
          box-shadow: 5px 5px 5px #aac4cd !important;
          border-radius: 18px;"
          class="btn background-ORANGE text-light btn-block btn-lg theme-search-results-item-price-btn"
          data-bs-toggle="modal"
          :id="cargo.id"
          :data-bs-target="'#ModalBasic_' + cargo.id">
        جزئیات | تماس
      </button>
      <button v-if="loading == true" type="button"
        style="box-shadow: 5px 5px 5px #aac4cd !important; border-radius: 18px"
        class="btn background-ORANGE text-light btn-block btn-lg theme-search-results-item-price-btn"
        v-on:click.prevent="getData(cargo.id)">
        {{ driver_call == null ? 'جزئیات | تماس' : 'جزئیات | تماس گرفته اید' }}
      </button>
      <button v-else class="btn background-ORANGE text-light btn-block btn-lg theme-search-results-item-price-btn"
        type="button" disabled="">
        <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
        درحال بارگذاری ...
      </button> -->
    </div>
  </div>
  <!-- <Detail :cargo="cargo" :getDetail="getDetail" /> -->
</template>

<script>
import moment from "moment";
// import Detail from "./Detail.vue";
import axios from "axios";
import delivery_methods from "@/delivery_methods";
import { reactive, ref } from "vue";
import TimeCalculation from "./TimeCalculation.vue";
// import L from "leaflet";
// import "leaflet.locatecontrol"; // Import plugin
// import "leaflet.locatecontrol/dist/L.Control.Locate.min.css"; // Import styles

// import axios from 'axios';
// import delivery_methods from '@/delivery_methods';
export default {
  props: {
    cargo: Object,
  },

  computed: {
    splitedListFrom() {
      var names = this.cargo.fromCity;
      var nameArr = names.split(",");
      return nameArr;
    },

    splitedListTo() {
      var names = this.cargo.toCity;
      var nameArr = names.split(",");
      return nameArr;
    }
  },

  data() {
    return {
      idUser: window.localStorage.getItem("idUser"),
      close: "close_" + this.cargo.id,
      driver_call: this.cargo.driver_call,
    };
  },
  components: {
    TimeCalculation
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getFormattedDates(date) {
      return moment(date).format("HH:mm");
    },
    roundNumber(value) {
      let val = (Math.round(value) / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    strippedUsername(to) {
      if (to.length > 20) {
        return to.slice(0, 20) + "...";
      }
      return to;
    },
  },
  setup() {
    const getDetail = reactive({
      fromLatLong: "",
      toLatLong: "",
      closeId: "",
      description: '',
      distanct: "0",
      ratingOwner: "",
      isAccepted: "",
      statusAcceptCargo: "",
      // dischargeAddress: "",
      // loadingAddress: '',
      // loadingDate: "",
      // deliveryTime: "",
      // bulk: "",
      // dangerousProducts: "",
    });

    const loading = ref(true);
    const map = ref();

    function getData(id) {
      // loading.value = false;
      document.getElementById(id).click();
      localStorage.setItem("closeId", id);

      if (history.pushState) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?modal=1";
        window.history.pushState({ path: newurl }, "", newurl);
      }

      let workorder = axios
        .get(`${delivery_methods.BASE_URL}api/driver/getLoadInfo/${id}/${window.localStorage.getItem("idUser")}`)
        .then(function (res) {
          loading.value = true;
          getDetail.fromLatLong = {
            latitude: res.data.loadInfo.originLatitude == 0 ? res.data.path.fromLatLong.latitude : res.data.loadInfo.originLatitude,
            longitude: res.data.loadInfo.originLongitude == 0 ? res.data.path.fromLatLong.longitude : res.data.loadInfo.originLongitude
          };
          getDetail.toLatLong = {
            latitude: res.data.loadInfo.destinationLatitude == 0 ? res.data.path.toLatLong.latitude : res.data.loadInfo.destinationLatitude,
            longitude: res.data.loadInfo.destinationLongitude == 0 ? res.data.path.toLatLong.longitude : res.data.loadInfo.destinationLongitude
          };
          getDetail.description = res.data.loadInfo.description;
          getDetail.ratingOwner = res.data.owner?.ratingOwner;
          getDetail.isAccepted = res.data.owner?.isAccepted;
          if (res.data.loadInfo.distanceCity == 0) {
            axios.post('https://api.geoapify.com/v1/routematrix?apiKey=4de1b6d17ec04871b4e8c56ea4ab0183',
              {
                "mode": "drive",
                "sources": [
                  {
                    "location": [
                      res.data.loadInfo.originCity.longitude,
                      res.data.loadInfo.originCity.latitude
                    ]
                  }
                ],
                "targets": [
                  {
                    "location": [
                      res.data.loadInfo.destinationCity.longitude,
                      res.data.loadInfo.destinationCity.latitude
                    ]
                  }
                ]
              }
            )
              .then(function (response) {
                getDetail.distanct = response.data.sources_to_targets[0][0].distance / 1000;
                axios.post("https://core.iran-tarabar.ir/api/storeDistanceCalculate", {
                    fromCity: res.data.loadInfo.origin_city_id,
                    toCity: res.data.loadInfo.destination_city_id,
                    value: response.data.sources_to_targets[0][0].distance / 1000,
                  })
                  .then(() => {
                    // console.log(res);
                  })
                  .catch(function (error) {
                    //
                  });
              })
              .catch(function (error) {
                // handle error
                console.log(error);
              });
          }
          axios.get(
            `${delivery_methods.BASE_URL}api/driver/checkDriverInquiry/${window.localStorage.getItem("idUser")}/${id}`
          )
          .then(function (res) {
            getDetail.statusAcceptCargo = res.data.result;
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });

      
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      }
      function showPosition(position) {
        localStorage.setItem("latitude", position.coords.latitude);
        localStorage.setItem("longitude", position.coords.longitude);
        axios.get(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=` + position.coords.latitude + `&longitude=` + position.coords.longitude + `&localityLanguage=fa`)
            .then((response) => {
              localStorage.setItem("city", response.data.city);
              axios.put(`https://dashboard.iran-tarabar.ir/api/driver/updateLocation/${window.localStorage.getItem("idUser")}`, {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                city: response.data.city,
              }).then(() => {
                  //
              });
            });
      }
      
      return workorder;
    }
    return { getData, getDetail, loading, map };

    // getDetail();
  },
};
</script>

<style scoped>
@import "@/assets/css/custom.css";
</style>